module.exports = __webpack_public_path__ + "media/images/city/053-hall-of-supreme-harmony-06bc9681c23d9af5c48e57369601beab.svg";